import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { ClaimController } from '../../../../controllers/ClaimController'
import { ClaimModel } from '../../../../models/ClaimModel'
import { FreeSampleEntry } from '../../../../models/FreeSampleEntry'
import { ISupportSpinner } from '../../../../shared/Ajax'
import { Backdrop } from '../../../../shared/Backdrop'
import { Option } from '../../../../shared/fields/Options'
import { Icon } from '../../../../shared/Icon'
import { Table } from '../../../../shared/table'
import { SaveCancelButtons } from '../../controls/SaveCancelButtons'
import { ScheduleInstructions } from '../../controls/ScheduleInstructions'
import {
  calculateFreeSampleTotal, freeSampleEntryColumns, FreeSampleEntryDetails, sortFreeSamples,
} from './FreeSampleEntryDetails'
import { ScheduleTypes } from '../../../../shared/Utility'

export interface FreeSamplesPageProps {
    history: H.History
    model: ClaimModel
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
}

export interface FreeSamplesPageState {
    loading: boolean
    freeSampleEntries: FreeSampleEntry[]
}

export class FreeSamplesPage extends React.Component<FreeSamplesPageProps, FreeSamplesPageState> implements ISupportSpinner {
    ajax: ClaimController
    table: Table<FreeSampleEntry>

    constructor(props: FreeSamplesPageProps) {
      super(props)

      this.ajax = new ClaimController()

      this.state = {
        loading: false,
        freeSampleEntries: props.model.freeSampleEntries ? props.model.freeSampleEntries.slice() : [],
      }
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    save = () => {
      this.table.saveAndClose((res) => {
        if (res) {
          if (this.state.freeSampleEntries.filter((r) => r.invalid).length == 0) {
            this.props.onChange({ freeSampleEntries: this.state.freeSampleEntries }, () => {
              this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.FreeSamples, () => {
                this.props.history.goBack()
              })
            })
          } else {
            alert('Please correct records marked with the warning sign.')
          }
        }
      })
    }

    render() {
      const columns = [...freeSampleEntryColumns(this.props.markets)]

      const invalidRows = this.state.freeSampleEntries.filter((r) => r.invalid).length > 0
      if (invalidRows) {
        columns.splice(0, 0, { name: '', content: (d) => (d.invalid ? <Icon type="warning" /> : <span />) })
      }

      const sortedFreeSamples = this.state.freeSampleEntries.slice()
      sortedFreeSamples.sort((a, b) => sortFreeSamples(a, b))

      return (
        <>
          <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

          <ScheduleInstructions
            title="Free Samples"
            helpLink="https://www.austrade.gov.au/ArticleDocuments/6917/Guide-to-Schedule-4.pdf.aspx"
          />

          <div className="mt-3 mb-3">
            <Alert className="emdg-page-alerts">
              <p>This category is capped at $15,000. However, all applicants should claim all eligible expenses.</p>
            </Alert>
          </div>

          <Table<FreeSampleEntry>
            id="table"
            label="Schedule 4: Free samples"
            ref={(r) => this.table = r}
            value={sortedFreeSamples}
            onChange={(freeSampleEntries) => this.setState({ freeSampleEntries })}
            columns={columns}
            renderSection={(p, i) => <FreeSampleEntryDetails {...p} markets={this.props.markets} claim={this.props.model} />}
            importUrl="/api/freesample/import"
            exportUrl="/api/freesample/export"
            match={(a, b) => a.id == b.id}
            total={calculateFreeSampleTotal}
            allowEdit
            allowImport
            invalidRows={invalidRows}
          />

          <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

          <Backdrop on={this.state.loading} />
        </>
      )
    }
}
